module.exports = __webpack_public_path__ + "../static/img/check.cfbbbfd1.png";